export default __webpack_public_path__ + "static/media/015.a6f8175f.jpg";